import { Loading } from '@farmshare/ui-components';
import { Box, Button, Chip, Tab, Tabs, Typography } from '@mui/material';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { userState } from 'state';

import { ProducerJobDashboard } from './producer-job-dashboard';
import { ProducerOrdersTab } from './producer-orders-tab';

function TabLabel({ label, count }: { label: string; count: number }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {label}
      {count > 0 && (
        <Chip label={count} size="small" color="default" variant="outlined" />
      )}
    </Box>
  );
}

export function ProducerDashboardTabs() {
  const user = useRecoilValue(userState);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [jobCount, setJobCount] = useState(0);
  const [orderCount, setOrderCount] = useState(0);

  const handleJobCount = useCallback((count: number) => setJobCount(count), []);
  const handleOrderCount = useCallback(
    (count: number) => setOrderCount(count),
    [],
  );

  if (!user) return <Loading />;

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          mb: 3,
        }}
      >
        <Box sx={{ pl: 1 }}>
          <Typography sx={{ mb: 0.5, typography: { xs: 'h5', md: 'h3' } }}>
            {user.first_name ? `Welcome, ${user.first_name}!` : 'Welcome!'}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {activeTab === 0
              ? 'Manage & track your processing jobs.'
              : 'Manage your orders.'}
          </Typography>
        </Box>
        {activeTab === 0 && (
          <Button
            variant="contained"
            sx={{ bgcolor: 'primary.main', flexShrink: 0 }}
            onClick={() => navigate('/scheduling')}
          >
            Schedule Job
          </Button>
        )}
      </Box>

      <Tabs
        value={activeTab}
        onChange={(_, val) => setActiveTab(val)}
        sx={{ mb: 2 }}
      >
        <Tab label={<TabLabel label="Your Jobs" count={jobCount} />} />
        <Tab label={<TabLabel label="Your Orders" count={orderCount} />} />
      </Tabs>

      <Box sx={{ display: activeTab === 0 ? 'block' : 'none' }}>
        <ProducerJobDashboard onCountChange={handleJobCount} />
      </Box>
      <Box sx={{ display: activeTab === 1 ? 'block' : 'none' }}>
        <ProducerOrdersTab onCountChange={handleOrderCount} />
      </Box>
    </Box>
  );
}
